const scoringTypeLabels: Record<string, string> = {
  time: 'Time (MM:SS)',
  reps: 'Reps',
  rounds: 'Rounds',
  rounds_reps: 'Rounds + Reps',
  metres: 'Metres',
  cals: 'Calories',
  distance: 'Distance',
  calories: 'Calories',
  points: 'Points',
};

const numericScoringTypes = new Set([
  'reps',
  'rounds',
  'metres',
  'cals',
  'distance',
  'calories',
  'points',
]);

export interface ScoreValueState {
  timeMinutes: string;
  timeSeconds: string;
  rounds: string;
  reps: string;
  numericValue: string;
}

export function getScoreInputConfig(scoringType: string): {
  label: string;
  unit: string | null;
  numeric: boolean;
} {
  const units: Record<string, string> = {
    metres: 'm',
    distance: 'm',
    cals: 'cal',
    calories: 'cal',
  };

  return {
    label: scoringTypeLabels[scoringType] || 'Score',
    unit: units[scoringType] || null,
    numeric: numericScoringTypes.has(scoringType),
  };
}

export function buildScoreValue(scoringType: string, state: ScoreValueState): number | string {
  switch (scoringType) {
    case 'time': {
      const mins = Number.parseInt(state.timeMinutes || '0', 10);
      const secs = Number.parseInt(state.timeSeconds || '0', 10);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
    case 'rounds_reps':
      return `${state.rounds || '0'}+${state.reps || '0'}`;
    default:
      return Number(state.numericValue || '0');
  }
}
